type TrackResult = { ok: true } | { ok: false; reason: string };

type SendConversionParams = {
  teamId: number;
  email: string;
  uid: string;
};
export const REDITUS_CONVERSION_STORAGE_KEY = "reditus:conversion";
const REDITUS_SENT_STORAGE_KEY = (value: string) => `reditus:conv:${value}`;

export function isReditusReady(): boolean {
  return typeof window !== "undefined" && typeof window.gr === "function";
}

async function waitForReditus(tries = 40, delayMs = 250): Promise<boolean> {
  while (tries-- > 0) {
    if (isReditusReady()) return true;

    await new Promise((r) => setTimeout(r, delayMs));
  }

  return false;
}

export function queueReditusConversion() {
  localStorage.setItem(REDITUS_CONVERSION_STORAGE_KEY, String(Date.now()));
}

export async function handleReditusPendingConversion(
  props: SendConversionParams,
): Promise<void> {
  const isConversion = localStorage.getItem(REDITUS_CONVERSION_STORAGE_KEY);

  if (!isConversion) {
    return;
  }

  const res = await trackReditusConversion(props);

  if (res.ok) {
    localStorage.removeItem(REDITUS_CONVERSION_STORAGE_KEY);
  } else {
    console.error("[Reditus] pending conversion failed:", res?.reason);
  }
}

export async function trackReditusConversion({
  teamId,
  email,
  uid,
}: SendConversionParams): Promise<TrackResult> {
  if (!isReditusReady()) {
    // wait for the script to be loaded
    const ready = await waitForReditus();
    if (!ready) return { ok: false, reason: "script_not_loaded" };
  }

  // Anti-duplicate: if already sent in this session/browser — skip
  if (localStorage.getItem(REDITUS_SENT_STORAGE_KEY(String(teamId)))) {
    return { ok: true };
  }

  try {
    // NB: the SDK itself does not provide a network callback;
    // we consider a successful function call as a success.
    (window.gr as ReditusStub)("track", "conversion", { email, uid });
    localStorage.setItem(REDITUS_SENT_STORAGE_KEY(String(teamId)), "1");

    return { ok: true };
  } catch {
    return { ok: false, reason: "gr_call_failed" };
  }
}
